import css from './AvatarStack.module.css'

interface AvatarStackSkeletonProps {
    count: number
    maxVisible?: number
}

// Pulsing placeholders rendered in place of an AvatarStack while the workspace
// members (avatars/colors) are still loading — the project member ids arrive with
// the project, but members load separately, so the avatars would otherwise pop in
// a frame later (SCD-888). Mirrors AvatarStack's layout so there's no shift on swap.
const AvatarStackSkeleton = ({ count, maxVisible = 5 }: AvatarStackSkeletonProps) => {
    const visibleCount = Math.min(count, maxVisible)

    return (
        <div className={css.stack}>
            {Array.from({ length: visibleCount }).map((_, index) => (
                <div
                    key={index}
                    className={css.avatarWrapper}
                    style={{ zIndex: visibleCount + index }}
                >
                    <div className={css.skeleton} />
                </div>
            ))}
        </div>
    )
}

export default AvatarStackSkeleton
